<template>
  <v-card>
    <v-list>
      <v-list-item>
        <v-list-item-avatar>
          <UserImage icon :src="userIcon"/>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{user.name}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider/>
    <v-list>
      <v-list-item @click="handleLogout">
        <v-list-item-title>
          {{label("logout")}}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
  import UserImage from "../atoms/UserImage";
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "organism",
    name: "AccountMenu",
    props: ["user"],
    computed: {
      userIcon () {
        return this.user.competition ? this.user.competition.icon : null;
      }
    },
    methods: {
      handleLogout () {
        this.$auth.logout({
          returnTo: process.env.VUE_APP_NISHIKA_CONNECT_URL || `${window.location.origin}`
        })
      },
    },
    components: {UserImage}
  }
</script>

<style scoped>

</style>
